import React from 'react';
import BaseIcon from './BaseIcon';

interface InfoIconProps {
  className?: string;
}

const InfoIcon: React.FC<InfoIconProps> = ({ className }) => (
  <BaseIcon className={className}>
    <circle cx="12" cy="12" r="10"></circle>
    <path d="m9 12 2 2 4-4"></path>
  </BaseIcon>
);

export default InfoIcon;
